import { linkQueryParams } from '../../utils/bi';
import { logger } from '../libs/logger';

const isFiverrUrl = (url: string) => url.includes('fiverr.com') || url.startsWith('/');
const isExternalUrl = (url: string) => !(url.includes('fiverr.com/resources') || url.startsWith('/resources'));

export const addLinkQueryParams = (htmlText: string) => {
    const hrefPattern = 'href="';

    try {
        const chunks = htmlText.split(hrefPattern);

        for (let i = 1; i < chunks.length; i++) {
            const closingBracketPosition = chunks[i].indexOf('"');
            const originalUrl = chunks[i].slice(0, closingBracketPosition).trim();

            if (isFiverrUrl(originalUrl)) {
                const mockUrlDomain = 'https://mock.com';
                const isRelativeUrl = originalUrl.startsWith('/');
                const url = new URL(isRelativeUrl ? `${mockUrlDomain}${originalUrl}` : originalUrl);

                Object.entries(linkQueryParams()).forEach(([key, value]) => {
                    url.searchParams.set(key, value);
                });

                const updatedUrl = url.toString();

                chunks[i] = chunks[i].replace(
                    originalUrl,
                    isRelativeUrl ? updatedUrl.slice(mockUrlDomain.length) : updatedUrl
                );
            }

            if (isExternalUrl(originalUrl)) {
                const attributes = ['target="_blank"'];

                if (isFiverrUrl(originalUrl)) {
                    attributes.push('rel="noopener"');
                } else {
                    attributes.push('rel="nofollow noopener"');
                }

                chunks[i] = chunks[i].replace('>', ` ${attributes.join(' ')}>`);
            }
        }

        return chunks.join(hrefPattern);
    } catch (error) {
        logger.error("Couldn't add analytics query params to links", { error });

        return htmlText;
    }
};
